function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["footer"];

var _this = this;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from 'react';
import { LoadingOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Tooltip, Button as AntButton } from 'antd';
import Button from '../button/button';
import { isDef } from '../../utils/is-def';
import { noop } from '../../utils/noop';
import { getClassNames } from '../../utils/getClassNames';

var WellHeader = function WellHeader(props) {
  var title = props.title || 'Well Title';
  return /*#__PURE__*/React.createElement("div", {
    ref: props.setRef,
    className: getClassNames('well-header')
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassNames('well-header-wrapper')
  }, isDef(props.header) ? props.header : /*#__PURE__*/React.createElement("div", {
    className: getClassNames('well-title')
  }, title), isDef(props.actions) && /*#__PURE__*/React.createElement("div", {
    className: getClassNames('well-actions')
  }, typeof props.actions === 'function' ? props.actions(_this) : props.actions), props.collapsible && /*#__PURE__*/React.createElement("div", {
    className: getClassNames('well-collapse-toggle')
  }, /*#__PURE__*/React.createElement(AntButton, {
    onClick: function onClick() {
      return isDef(props.onCollapsedChange) && props.onCollapsedChange();
    }
  }, props.collapsed ? /*#__PURE__*/React.createElement(MenuUnfoldOutlined, null) : /*#__PURE__*/React.createElement(MenuFoldOutlined, null)))));
};

var WellHeaderExtension = function WellHeaderExtension(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: getClassNames('well-header-extension')
  }, props.children);
};

var WellBody = function WellBody(props) {
  return /*#__PURE__*/React.createElement("div", {
    ref: props.setRef,
    className: getClassNames('well-body')
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassNames('well-loader-wrapper')
  }, /*#__PURE__*/React.createElement(LoadingOutlined, {
    spin: true
  })), /*#__PURE__*/React.createElement("div", {
    className: getClassNames('well-body-wrapper')
  }, props.children));
};

var SubmitButton = function SubmitButton(props) {
  var submitText = props.text || 'Submit';
  var submitEnabled = !props.disabled;
  var btn = /*#__PURE__*/React.createElement("span", {
    className: getClassNames('well-submit', {
      disabled: props.disabled
    })
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-submit",
    type: "primary",
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = isDef(props.onClick);

              if (!_context.t0) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return props.onClick();

            case 4:
              _context.t0 = _context.sent;

            case 5:
              return _context.abrupt("return", _context.t0);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })),
    triggerOnEnter: props.triggerOnEnter,
    disabled: props.disabled,
    actions: props.actions
  }, /*#__PURE__*/React.createElement("span", null, submitText)));
  return submitEnabled ? btn : /*#__PURE__*/React.createElement(Tooltip, {
    title: props.disabledTooltip || 'Submit Disabled'
  }, btn);
};

var CancelButton = function CancelButton(props) {
  return /*#__PURE__*/React.createElement("span", {
    className: getClassNames('well-cancel')
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-cancel",
    type: "ghost",
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = isDef(props.onClick);

              if (!_context2.t0) {
                _context2.next = 5;
                break;
              }

              _context2.next = 4;
              return props.onClick();

            case 4:
              _context2.t0 = _context2.sent;

            case 5:
              return _context2.abrupt("return", _context2.t0);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))
  }, /*#__PURE__*/React.createElement("span", null, props.text || 'Cancel')));
};

var WellButtons = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(WellButtons, _React$PureComponent);

  var _super = _createSuper(WellButtons);

  function WellButtons() {
    _classCallCheck(this, WellButtons);

    return _super.apply(this, arguments);
  }

  _createClass(WellButtons, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var hideSubmit = props.hideSubmit,
          hideCancel = props.hideCancel;
      var showSubmit = !hideSubmit;
      var showCancel = !hideCancel;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showCancel && /*#__PURE__*/React.createElement(CancelButton, {
        text: props.cancelText,
        onClick: props.onCancel
      }), showSubmit && /*#__PURE__*/React.createElement(SubmitButton, {
        text: props.submitText,
        onClick: props.onSubmit,
        disabled: props.disableSubmit,
        disabledTooltip: props.disabledSubmitTooltip,
        triggerOnEnter: props.submitOnEnter,
        actions: props.submitActions
      }));
    }
  }]);

  return WellButtons;
}(React.PureComponent);

WellButtons.Submit = SubmitButton;
WellButtons.Cancel = CancelButton;

var WellFooter = function WellFooter(props) {
  var footer = props.footer,
      buttonProps = _objectWithoutProperties(props, _excluded);

  var useCustomFooter = !!footer;
  return /*#__PURE__*/React.createElement("div", {
    ref: props.setRef,
    className: getClassNames('well-footer')
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassNames('well-footer-wrapper')
  }, useCustomFooter ? footer : /*#__PURE__*/React.createElement(WellButtons, buttonProps)));
};

var _default = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(_default, _React$PureComponent2);

  var _super2 = _createSuper(_default);

  function _default() {
    var _this2;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {};
    _this2.wellRef = void 0;
    _this2.wellContentRef = void 0;
    _this2.wellHeaderRef = void 0;
    _this2.wellBodyRef = void 0;
    _this2.wellFooterRef = void 0;

    _this2.handleCollapsedChange = function () {
      return _this2.setState(function (_ref3) {
        var collapsed = _ref3.collapsed;
        return {
          collapsed: !collapsed
        };
      });
    };

    return _this2;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      var _this3 = this,
          _getClassNames;

      var props = this.props;
      var loading = props.loading,
          disabled = props.disabled,
          mode = props.mode;
      var baseProps = {
        loading: loading,
        disabled: disabled,
        mode: mode
      };
      var showHeader = !props.hideHeader;
      var showFooter = !props.hideFooter;
      var collapsed = this.state.collapsed || false;
      return /*#__PURE__*/React.createElement("div", {
        id: props.id,
        ref: function ref(el) {
          return _this3.wellRef = el;
        },
        className: getClassNames('well', props.className, (_getClassNames = {}, _defineProperty(_getClassNames, "mode-".concat(props.mode || 'default'), true), _defineProperty(_getClassNames, 'loading', props.loading), _defineProperty(_getClassNames, 'collapsed', collapsed), _defineProperty(_getClassNames, 'expanded', !collapsed), _defineProperty(_getClassNames, 'disabled', props.disabled), _defineProperty(_getClassNames, 'hide-header', props.hideHeader), _defineProperty(_getClassNames, 'show-header', !props.hideHeader), _defineProperty(_getClassNames, 'hide-footer', props.hideFooter || collapsed && props.hideFooterWhenCollapsed), _defineProperty(_getClassNames, 'show-footer', !props.hideFooter && !(collapsed && props.hideFooterWhenCollapsed)), _getClassNames)),
        style: props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('well-wrapper')
      }, /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          return _this3.wellContentRef = el;
        },
        className: getClassNames('well-content')
      }, showHeader && /*#__PURE__*/React.createElement(WellHeader, _extends({
        setRef: function setRef(el) {
          return _this3.wellHeaderRef = el;
        },
        title: props.title,
        header: props.header,
        collapsible: props.collapsible,
        collapsed: collapsed,
        onCollapsedChange: this.handleCollapsedChange,
        actions: props.actions
      }, baseProps)), showHeader && isDef(props.headerExtension) && /*#__PURE__*/React.createElement(WellHeaderExtension, null, this.props.headerExtension), /*#__PURE__*/React.createElement(WellBody, {
        setRef: function setRef(el) {
          return _this3.wellBodyRef = el;
        }
      }, props.children)), showFooter && /*#__PURE__*/React.createElement(WellFooter, _extends({
        setRef: function setRef(el) {
          return _this3.wellFooterRef = el;
        },
        footer: props.footer,
        hideSubmit: props.hideSubmit,
        submitText: props.submitText,
        disableSubmit: props.disabled || props.disableSubmit,
        disabledSubmitTooltip: props.disabledSubmitTooltip,
        submitOnEnter: props.submitOnEnter,
        onSubmit: collapsed ? noop : props.onSubmit,
        hideCancel: props.hideCancel,
        cancelText: props.cancelText,
        onCancel: props.onCancel,
        submitActions: props.submitActions
      }, baseProps))));
    }
  }]);

  return _default;
}(React.PureComponent);

_default.Buttons = WellButtons;
export { _default as default };